import React from "react";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Icon from "@client.components/Icon";
import "./NavImgLink.scss";

export const NavImgLink = ({ icon, url, translationKey, showTitle }) => {
  const { t } = useTranslation();
  const name = t(translationKey);
  return (
    <NavLink
      to={url}
      title={name}
      className={(navData) => {
        return classNames("nav-img-link", {
          "with-text": showTitle,
          active: navData.isActive,
        });
      }}
      data-testid={icon}
    >
      <Icon name={icon} />
      {showTitle && <div className="title">{name}</div>}
    </NavLink>
  );
};

NavImgLink.propTypes = {
  icon: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  translationKey: PropTypes.string,
  showTitle: PropTypes.bool,
};
